// External
import { NgModule } from '@angular/core';

// Internal
import { PageNotFoundComponent } from './page-not-found.component';
import { PageNotFoundRoutingModule } from './page-not-found.routes';
import { EmptyStateModule } from 'src/app/common/components/empty-state/empty-state.module';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from 'src/app/common/components/directives.module';

@NgModule({
    declarations: [
      PageNotFoundComponent
    ],
    imports: [
        PageNotFoundRoutingModule,
        TranslateModule,
        EmptyStateModule,
        DirectivesModule
    ],
    exports: [ PageNotFoundComponent ]
})

export class PageNotFoundModule {}
